var hasOwnProperty = {}.hasOwnProperty;
module.exports = function(it, key){
  return hasOwnProperty.call(it, key);
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/core-js/library/modules/$.has.js
 ** module id = 172
 ** module chunks = 0
 **/